export const POST_STUDIO_GENERATION_STAGE = {
  ANALYSIS: "analysis",
  GENERATION: "generation",
  FINALIZING: "finalizing",
  READY: "ready",
  ERROR: "error",
} as const;

export const GENERATION_STAGE_ORDER: Array<
  Exclude<
    import("./post-studio-generation-sheet.types").PostStudioGenerationStage,
    | typeof POST_STUDIO_GENERATION_STAGE.READY
    | typeof POST_STUDIO_GENERATION_STAGE.ERROR
  >
> = [
  POST_STUDIO_GENERATION_STAGE.ANALYSIS,
  POST_STUDIO_GENERATION_STAGE.GENERATION,
  POST_STUDIO_GENERATION_STAGE.FINALIZING,
];

export const POST_STUDIO_COPIED_DURATION_MS = 2000;
